export default "__VITE_ASSET__gKRu0K4r__"